import { IValidator } from "../../../Validation/IValidator";
import { HoursExceptionModel, EntryModel, HoursOfOperationType } from "@truckdown/locations";
import { getTimeRange, rangesOverlap } from '../../../utilities';

interface IPropertyValidator {
    key: string;
    validator: () => boolean;
    message: () => string;
}

interface ValidationObject {
    msg: string;
    isValid: boolean;
}

interface TempExceptionModel extends HoursExceptionModel {
    dateRange?: [Date, Date]; 
}

enum ExceptionKind {
  New = 'new',
  Existing = 'existing'
}

export class ExceptionValidator implements IValidator {
    constructor(excpetion: TempExceptionModel | undefined, index: number | "new", entryIndex?: number) {
        this._excpetion = excpetion;
        this._itemIndex = index;
        this._entryIndex = entryIndex;
        this._validators = this.getValidators();
    }

    private _excpetion: TempExceptionModel | undefined;
    private _validators: IPropertyValidator[];
    private _itemIndex: number | "new";
    private _entryIndex: number | undefined;
    

    private getValidators(): IPropertyValidator[] {
        let entry = undefined;
        if (this._entryIndex || this._entryIndex === 0) {
            entry = this._excpetion?.entries.entries[this._entryIndex]
        }
        const entries = this._excpetion?.entries.entries as EntryModel[];


          const rules: IPropertyValidator[] = [];

  // high-level checks
  rules.push(
    {
        key: `name-${this._itemIndex}`,
        message: () => "Exception name is required.",
        validator: () => !!this._excpetion?.name && this._excpetion?.name.length > 0
    },
    {
        key: `date-${this._itemIndex}`,
        message: () => "Exception date is required.",
        validator: () => {
            const dateRange = this._excpetion?.dateRange;
            return !!dateRange;
        }
    },
    {
        key: `type-${this._itemIndex}`,
        message: () => "Select exception type",
        validator: () => {
            const type = this._excpetion?.type;
            return type !== undefined && type !== HoursOfOperationType.Unknown;
        }
    },
    {
        key: `entries-${this._itemIndex}`,
        message: () => "Add hours of operation",
        validator: () => {
                   
            return this._excpetion?.type != HoursOfOperationType.SelectHours || (this._excpetion?.type == HoursOfOperationType.SelectHours && entries.length > 0);
        }
    }
  );

  // checks in entryIndex is provided

   if (this._entryIndex !== undefined) {
    const entry = this._excpetion?.entries.entries[this._entryIndex];
    const entries = this._excpetion?.entries.entries ?? [] as EntryModel[];

    rules.push(
      {
        key: `startTime-${this._itemIndex}-${this._entryIndex}`,
        message: () => "Start time is required.",
        validator: () => !!entry?.startTime,
      },
      {
        key: `endTime-${this._itemIndex}-${this._entryIndex}`,
        message: () => "End time is required.",
        validator: () => !!entry?.endTime,
      },
      {
        key: `range-${this._itemIndex}-${this._entryIndex}`,
        message: () => "Start and end time cannot be the same.",
        validator: () =>
          !entry ||
          entry.startTime !== entry.endTime ||
          (entry.startTime === "00:00" && entry.endTime === "00:00"),
      },
      {
        key: `overlap-${this._itemIndex}-${this._entryIndex}`,
        message: () => "This time overlaps with another entry.",
        validator: () => {
          if (!entry || !entry.startTime || !entry.endTime) return true;
          const current = getTimeRange(entry);
          return !entries.some(
            (other) =>
              other !== entry && rangesOverlap(current, getTimeRange(other))
          );
        },
      }
    );
  }

  return rules;
      
};


    validate(key?: string): boolean {
        if (key) {
            let validator = this._validators.find(v => v.key == key);
            if (validator) {
                const isValid = validator.validator();
                if (!isValid) {
                    this.errors[key] = validator.message();
                } else {
                    delete this.errors[key];
                }
                return isValid;
            }
            return true;
        } else {
            let isValid = true;
            for (let i = 0; i < this._validators.length; i++) {
                let v = this._validators[i];
                if (!v.validator()) {
                    isValid = false;
                    delete this.errors[v.key];
                    this.errors[v.key] = v.message();
                } else {
                    delete this.errors[v.key];
                }
            }
            return isValid;
        }
    }

    reset() {
        this.errors = {};
    }

    errors: { [key: string]: string } = {};
}